<template>
  <div>
    <b-row>
      <b-col lg="12">
        <div class="text-center p-5 row" v-if="isLoading">
          <semipolar-spinner :animation-duration="2000" :size="80" color="#63c2de" class="offset-6"></semipolar-spinner>
        </div>
        <table-strategy-action
          :table-data="items"
          :fields="fields"
          caption=" <h4><i class='fas fa-chess mr-2'></i> Estrategia de acción</h4>"
          v-else
        ></table-strategy-action>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { shuffleArray } from "@/shared/utils";
import TableStrategyAction from "./TableStrategyAction";
import store from "../../store";
import { SemipolarSpinner } from "epic-spinners";

export default {
  name: "Strategy",
  components: { TableStrategyAction, SemipolarSpinner },
  data: () => {
    return {
      items: [],
      itemsArray: [],
      fields: [
        { key: "name", label: "Nombre", sortable: true },
        { key: "description", label: "Descripción", sortable: true },
        { key: "date_start", label: "Fecha inicio", sortable: true },
        { key: "date_end", label: "Fecha cierre", sortable: true },
        { key: "acciones", label: "Acciones" }
      ],
      isLoading: false
    };
  },
  mounted() {
    this.getStrategyActions();
  },
  methods: {
    getStrategyActions() {
      var strategyActions = store.getters.getStrategyActions;
      if (strategyActions.length == 0) {
        this.isLoading = true;
        store.dispatch("getStrategyActions").then(() => {
          strategyActions = store.getters.getStrategyActions;
          shuffleArray([strategyActions]);
          this.isLoading = false;
          this.items = strategyActions;
          this.itemsArray = strategyActions;
          return;
        });
      } else {
        shuffleArray([strategyActions]);
        this.items = strategyActions;
        this.itemsArray = strategyActions;
        return;
      }
    }
  }
};
</script>
